export default __webpack_public_path__ + "static/media/ic-caretDownBlack.b416c59d.svg";